import { Grid } from '@mui/material';
import { InputButton } from '@abbott-components/core';
import {
  WorkflowEngineContext,
  WorkflowEngineMode
} from '../../WorkflowEngine/workflowEngineReducer';
import { useContext } from 'react';
import LastUpdatedView from './LastUpdatedView';
import KebabMenu from './KebabMenu';

const UnpublishedView = ({
  handleOpenPublishDialog
}: {
  handleOpenPublishDialog: () => void;
}) => {
  const { state } = useContext(WorkflowEngineContext);

  const { mode } = state;

  return (
    <>
      {mode !== WorkflowEngineMode.PREVIEW ? (
        <Grid item sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <LastUpdatedView />
          <KebabMenu />
        </Grid>
      ) : (
        <Grid item sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <InputButton
            name="openPublishDialogButton"
            type="button"
            onClick={handleOpenPublishDialog}
            sx={{
              height: '37px'
            }}
          >
            PUBLISH
          </InputButton>
          <KebabMenu />
        </Grid>
      )}
    </>
  );
};

export default UnpublishedView;
